import { definedMap } from "collection-utils";
import { asString } from "common/components/component-helpers";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { components as fluentComponents } from "fluent-components/fluent-components";
import type { PropertiesOfComponent } from "fluent-components/fluent-components-spec";
import type { FluentComponentName } from "fluent-components/fluent-components-types";
import { makeFluentComponentUI } from "generator/components/fluent-components-handlers";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import type { WireBackend } from "hydrated-ui/types";

export type Renderers = {
    [Name in keyof Partial<typeof fluentComponents>]: React.FC<
        PropertiesOfComponent<typeof fluentComponents[Name]> & { readonly backend: WireBackend }
    >;
};

export const renderers: Renderers = {};

export function makeFluentRenderer(componentName: FluentComponentName) {
    const component = fluentComponents[componentName];
    const {
        spec: [, , ...specs],
    } = makeFluentComponentUI(component, componentName);

    const render = renderers[componentName];
    if (render === undefined) return undefined;

    const Renderer: GlideFunctionalRenderer = p => {
        const { getValueProducers, ctx } = p;
        const [force] = useForce();
        const [pvs] = useForceValueProducers(getValueProducers, force, ctx);

        // TODO improve this type
        const props: any = {};

        specs.forEach(([name], i) => {
            // FIXME support all ArgumentSpecs
            props[name as string] = definedMap(pvs[i], asString);
        });

        return render(props);
    };

    return Renderer;
}
